import { LocalNavigationItem } from '@acast-tech/decibel';
import { Link } from 'react-router-dom';
import type { SelectedNetwork } from '@/types';
import { mixpanelTrack } from '@/utils/mixpanelUtils/asyncMixpanel';
import { MIXPANEL_EVENT, RevenueDashboardWidget } from '@/utils/mixpanelUtils/events';

export interface YearTabsProps {
  selectedYear: string;
  selectedNetwork: SelectedNetwork;
  isPending: boolean;
  years: string[];
}

const YearTabs = ({ selectedYear, selectedNetwork, isPending, years }: YearTabsProps) => (
  <div className="inline-flex">
    {isPending
      ? Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="flex items-center justify-center p-3 mr-2"
            data-testid="skeleton-loader"
          >
            <div className="w-16 h-5 flex items-center justify-center bg-gray-200 animate-pulse rounded-sm" />
          </div>
        ))
      : years.map((year: string) => (
          <LocalNavigationItem key={year} selected={selectedYear == year} onClick={() => {
            mixpanelTrack(MIXPANEL_EVENT.payouts.yearTab.clicked, {
              widget: RevenueDashboardWidget.YearsTabs,
              page: 'payouts',
              year: year,
            });
          }}>
            <Link
              className="px-4 py-2 text-base inline-block"
              to={`/${selectedNetwork.id}/payouts/${year}`}
            >
              {year}
            </Link>
          </LocalNavigationItem>
        ))}
  </div>
);

export default YearTabs;
